import React, { useEffect, useMemo, useRef, useState } from "react"
import LocationImg from "../../../../../assets/avia/sidebar/location.png"
import SearchInput from "./SearchInput"
import { NUMBER_OF_VIEWS } from "../../utils/variables/sidebar"
import ShowMore from "./ShowMore"
import CircularCheckbox from "../ui/CircularCheckbox"
import ItemsFlexWrapper from "./ItemsFlexWrapper"
import { useTranslation } from "react-i18next"
import { cn } from "../../../../../lib"
import AnimatedList from "./AnimatedList"
import { AnimatePresence } from "framer-motion"
import { useClickOutside } from "../../hooks"

const Airports = ({ airports, onChange, initialSelectedCountryIds }) => {
  const { t } = useTranslation()

  // states
  const [search, setSearch] = useState("")
  const [showAllAirports, setShowAllAirports] = useState(false)

  //
  const sectionRef = useRef(null)

  // cuse hooks

  useClickOutside(sectionRef, () => setShowAllAirports(false))

  //
  const filteredAirports = useMemo(() => {
    const query = search.toLowerCase()

    return [...airports].sort((a, b) => {
      const aName = a.name.toLowerCase()
      const bName = b.name.toLowerCase()
      const aCountry = a.country_name.toLowerCase()
      const bCountry = b.country_name.toLowerCase()

      const aMatch = aName.includes(query) || aCountry.includes(query)
      const bMatch = bName.includes(query) || bCountry.includes(query)

      if (aMatch && !bMatch) return -1
      if (!aMatch && bMatch) return 1

      return aName.localeCompare(bName)
    })
  }, [airports, search])

  const selectedAirportsCount = useMemo(() => {
    return airports.filter((airport) => airport.is_selected).length
  }, [airports])

  return (
    <div ref={sectionRef} className="mb-6 relative ">
      <div className="flex items-center justify-between mb-1">
        <p className="flex items-center gap-1">
          <img src={LocationImg} alt="" className="w-[17px] h-[17px]" />
          <span className="text-gray-700 font-medium">{t("admin.airports")}</span>
        </p>
      </div>

      <div className="flex gap-2 mb-3">
        <SearchInput value={search} onChange={(e) => setSearch(e.target.value)} />
        {/* <label className="flex items-center gap-1.5 px-2">
          <input
            type="checkbox"
            checked={selectedAirports.all}
            onChange={() => handleAirportChange("all")}
            className="cursor-pointer w-4 h-4 border-gray-300 rounded accent-green-600 checked:bg-green-600 checked:border-green-600 focus:ring-green-500"
          />
          <span className="text-xs text-dark-gray whitespace-nowrap">
            {t("admin.log.status.select.all")}
          </span>
        </label> */}
      </div>
      <ItemsFlexWrapper>
        <AnimatePresence mode="sync">
          {filteredAirports.map((airport, index) => {
            const shouldShow = showAllAirports || index < NUMBER_OF_VIEWS

            return (
              <AnimatedList
                key={airport.id}
                isVisible={shouldShow}
                index={index}
                delayFromIndex={index >= NUMBER_OF_VIEWS ? 0.03 : 0}
              >
                <CircularCheckbox checked={airport.is_selected}>
                  <button
                    onClick={() => onChange(airport.id)}
                    className={cn(
                      "w-full ml-2 text-dark-gray text-[15px] flex items-center gap-1 hover:bg-gray-50 rounded-xl transition relative disabled:cursor-not-allowed disabled:after:absolute disabled:after:inset-0 disabled:after:flex disabled:after:items-center disabled:after:justify-center disabled:after:text-xl disabled:opacity-60"
                    )}
                    disabled={
                      initialSelectedCountryIds.includes(airport.id) ||
                      (selectedAirportsCount === 3 && !airport.is_selected)
                    }
                  >
                    <span className="flex-shrink-0">{t("admin.airports")}:</span>
                    <span className="flex-shrink-0">{airport.country_name}</span>
                    <span className="truncate min-w-0 max-w-[130px]">{airport.name}</span>
                    <span className="flex-shrink-0">{airport.iata}</span>
                  </button>
                </CircularCheckbox>
              </AnimatedList>
            )
          })}
        </AnimatePresence>
      </ItemsFlexWrapper>

      {filteredAirports.length > NUMBER_OF_VIEWS && (
        <ShowMore showAll={showAllAirports} onClick={() => setShowAllAirports(!showAllAirports)} />
      )}
      <div className="absolute -bottom-3 left-0 right-0 border-b border-light-gray/25"></div>
    </div>
  )
}

export default Airports
